
const getPossibleNumber = val => {
  const parsed = parseInt(val, 10)
  if (isNaN(parsed) || parsed.length || val.length !== (parsed + "").length) {
    return val || undefined
  }
  return parsed || undefined
}

export default keys => ({
  created() {
    this.extractQueryParameters()
  },
  methods: {
    extractQueryParameters() {
      const query = this.$route.query;
      keys.forEach(key => {
        const value = getPossibleNumber(query[key])
        if (value) this[key] = value
      })
    },
  },
  watch: {
    ...keys.reduce((obj, key) => ({
      ...obj,
      [key]: function(val) {
        this.$router.replace({ query: {
          ...this.$route.query,
          [key]: getPossibleNumber(val),
        }}).catch(() => {})
      },
    }), {}),
  },
})
